import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CollectionDashboardResponse from "../CollectionDashboardResponse";
import ModelProxyClass from "./ModelProxyClass";
import CollectionLocationActivity from "../CollectionLocationActivity";


/**
 * @class CollectionDashboardResponseBase
 * @extends ModelBaseClass
 * @property {number} totalAmountFills
 * @property {number} totalAmountVgtDrops
 * @property {number} totalEmergencyRamClearVgtDropCount (integer)
 * @property {number} totalAmountBvDrops
 * @property {number} totalAmountRtAudits
 * @property {[CollectionLocationActivity]} collectionLocationActivities
 */
class CollectionDashboardResponseBase extends ModelBaseClass {
	/**
	 * @type {number} totalAmountFills
	 */
	totalAmountFills;
	/**
	 * @type {number} totalAmountVgtDrops
	 */
	totalAmountVgtDrops;
	/**
	 * @type {number} totalEmergencyRamClearVgtDropCount (integer)
	 */
	totalEmergencyRamClearVgtDropCount;
	/**
	 * @type {number} totalAmountBvDrops
	 */
	totalAmountBvDrops;
	/**
	 * @type {number} totalAmountRtAudits
	 */
	totalAmountRtAudits;
	/**
	 * @type {[CollectionLocationActivity]} collectionLocationActivities
	 */
	collectionLocationActivities;

	/**
	 * Instantiates a new instance of CollectionDashboardResponse based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CollectionDashboardResponse}
	 */
	static create(genericObject) {
		const newCollectionDashboardResponse = new CollectionDashboardResponse();
		newCollectionDashboardResponse.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCollectionDashboardResponse;
	}

	/**
	 * Instantiates a new array of CollectionDashboardResponse based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CollectionDashboardResponse]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCollectionDashboardResponseArray = [];
		genericArray.forEach(genericObject => {
			newCollectionDashboardResponseArray.push(CollectionDashboardResponse.create(genericObject));
		});
		return newCollectionDashboardResponseArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('totalAmountFills', 'float'),
	ModelBaseClass.createModelProperty('totalAmountVgtDrops', 'float'),
	ModelBaseClass.createModelProperty('totalEmergencyRamClearVgtDropCount', 'integer'),
	ModelBaseClass.createModelProperty('totalAmountBvDrops', 'float'),
	ModelBaseClass.createModelProperty('totalAmountRtAudits', 'float'),
	ModelBaseClass.createModelProperty('collectionLocationActivities', '[CollectionLocationActivity]'),
];

export default CollectionDashboardResponseBase;
